export const primitiveColor = {
  black: '#000000',
  white: '#FFFFFF',
  current: 'currentColor',
  transparent: 'transparent',
  /*  color primitive */
  gray: {
    50: '#F6F7F8',
    100: '#F0F2F3',
    200: '#E3E6E9',
    300: '#CBD1D7',
    400: '#ACB5BE',
    500: '#8A96A3',
    600: '#707F8F',
    700: '#55616D',
    800: '#363E45',
    900: '#22272B',
    950: '#121417',
    'alpha-900': 'rgba(8, 15, 23, 0.90)',
    'alpha-800': 'rgba(4, 14, 24, 0.80)',
    'alpha-700': 'rgba(0, 16, 31, 0.66)',
    'alpha-600': 'rgba(0, 26, 50, 0.56)',
    'alpha-500': 'rgba(0, 26, 50, 0.46)',
    'alpha-400': 'rgba(0, 30, 57, 0.33)',
    'alpha-300': 'rgba(0, 30, 57, 0.21)',
    'alpha-200': 'rgba(0, 30, 57, 0.12)',
    'alpha-100': 'rgba(0, 30, 57, 0.06)',
    'alpha-inverse-900': 'rgba(251, 253, 255, 0.95)',
    'alpha-inverse-800': 'rgba(246, 251, 255, 0.85)',
    'alpha-inverse-700': 'rgba(244, 249, 255, 0.75)',
    'alpha-inverse-600': 'rgba(240, 247, 255, 0.65)',
    'alpha-inverse-500': 'rgba(229, 241, 255, 0.55)',
    'alpha-inverse-400': 'rgba(225, 238, 255, 0.45)',
    'alpha-inverse-300': 'rgba(211, 230, 255, 0.35)',
    'alpha-inverse-200': 'rgba(200, 224, 255, 0.25)',
    'alpha-inverse-100': 'rgba(192, 220, 255, 0.15)',
    'alpha-inverse-50': 'rgba(189, 219, 255, 0.10)',
    'alpha-inverse-0': 'rgba(255, 255, 255, 0.00)'
  },
  violet: {
    50: '#F4F4FF',
    100: '#F0F0FF',
    200: '#D4CFFF',
    300: '#BFB9FD',
    400: '#9B92FC',
    500: '#7B6FFB',
    600: '#5E50FA',
    700: '#4939F3',
    800: '#3024AD',
    900: '#1E176D',
    950: '#120D3F',
    'alpha-600': 'rgba(19, 0, 232, 0.67)',
    'alpha-100': 'rgba(19, 0, 232, 0.06)'
  },
  blue: {
    50: '#F0F6FF',
    100: '#E9F3FF',
    200: '#C7DEFE',
    300: '#A3C9FF',
    400: '#6CA9FF',
    500: '#3A8CFF',
    600: '#0E72FF',
    700: '#0062F5',
    800: '#0049AF',
    900: '#002C68',
    950: '#001F4B',
    'alpha-600': 'rgba(0, 77, 219, 0.78)',
    'alpha-100': 'rgba(0, 102, 255, 0.08)'
  },
  red: {
    50: '#FFF3F3',
    100: '#FFEFEF',
    200: '#FFC3C3',
    300: '#FFADAD',
    400: '#FF8585',
    500: '#FF5C5C',
    600: '#F91F1F',
    700: '#DF0000',
    800: '#A60404',
    900: '#590202',
    950: '#3B0202',
    'alpha-600': 'rgba(240, 0, 0, 0.80)',
    'alpha-100': 'rgba(255, 0, 0, 0.06)'
  },
  green: {
    50: '#E9F9F1',
    100: '#E3FBEF',
    200: '#C6F1DB',
    300: '#A5E9C7',
    400: '#70DBA6',
    500: '#3BCE85',
    600: '#14B866',
    700: '#009C4F',
    800: '#0C6E3D',
    900: '#084929',
    950: '#052C19',
    'alpha-600': 'rgba(10, 138, 74, 0.74)',
    'alpha-100': 'rgba(0, 227, 114, 0.10)'
  },
  orange: {
    50: '#FFF6EE',
    100: '#FFF2E5',
    200: '#FFD6B2',
    300: '#FFC999',
    400: '#FFB370',
    500: '#FF973D',
    600: '#FF7C0A',
    700: '#F16D09',
    800: '#B25300',
    900: '#763700',
    950: '#411E00',
    'alpha-600': 'rgba(240, 88, 0, 0.72)',
    'alpha-100': 'rgba(255, 106, 0, 0.09)'
  },
  yellow: {
    50: '#FFFAE2',
    100: '#FFF8D3',
    200: '#FFF4BF',
    300: '#FFEC8F',
    400: '#FFE357',
    500: '#FFD70F',
    600: '#FFCC00',
    700: '#D1A700',
    800: '#947600',
    900: '#5C4900',
    950: '#3C3000'
  },
  pink: {
    50: '#FEF1F9',
    100: '#FEECF7',
    200: '#FDDAF0',
    300: '#FBB6E1',
    400: '#F986CD',
    500: '#F65BBB',
    600: '#EF199D',
    700: '#D50B88',
    800: '#93085E',
    900: '#4A042F',
    950: '#2D021C',
    'alpha-600': 'rgba(232, 0, 143, 0.84)',
    'alpha-100': 'rgba(232, 0, 143, 0.07)'
  },
  olive: {
    50: '#F9FDE1',
    100: '#F5FCCA',
    200: '#EDF99F',
    300: '#E3F566',
    400: '#CFE920',
    500: '#C0DA16',
    600: '#A4BA12',
    700: '#8A9C16',
    800: '#6F7D12',
    900: '#4F590D',
    950: '#3B430a'
  },
  cyan: {
    50: '#E9FBFB',
    100: '#DCF9F9',
    200: '#BEF4F4',
    300: '#97EDED',
    400: '#6BE5E5',
    500: '#26D9D9',
    600: '#22BEBE',
    700: '#1DA5A5',
    800: '#178282',
    900: '#0F5757',
    950: '#093535'
  },
  cornflower: {
    50: '#F1F3FF',
    100: '#E5E9FF',
    200: '#D6DDFF',
    300: '#BDC8FF',
    400: '#99AAFF',
    500: '#7088FF',
    600: '#3F5FFF',
    700: '#2F4BDA',
    800: '#1D34A5',
    900: '#13226C',
    950: '#0D174a'
  },
  magenta: {
    50: '#FCEFFF',
    100: '#FBE5FF',
    200: '#F8D6FF',
    300: '#F2B2FF',
    400: '#EA80FF',
    500: '#E047FF',
    600: '#C300EB',
    700: '#9700B6',
    800: '#75008D',
    900: '#4E005E',
    950: '#2C0035'
  }
};
